export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_656_USER': 'User',
    '_7367___TO_GOAL': '% To Goal',
    '_767___TO_GOAL': '% to Goal',
    '_768___TO_TARGET': '% to Target',
    '_125_ACTIVE': 'Active',
    '_725_ACTUAL': 'Actual',
    '_7440_CLOSED': 'Closed',
    '_202_DAILY': 'Daily',
    '_746_DETAILS': 'Details',
    '_7369_GAP_TO_OPPORTUNITY_LINE': 'Gap to Opportunity Line',
    '_721_GOAL': 'Goal',
    '_527_METRICS': 'Metrics',
    '_204_MONTHLY': 'Monthly',
    '_852_NO_DATA': 'No Data',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7310_SESSION_DATE': 'Session Date',
    '_7309_SESSION_TYPE': 'Session Type',
    '_7347_OBSERVER': 'Observer',
    '_7368_OPPORTUNITY_THRESHOLD': 'Opportunity Threshold',
    '_7441_PENDING_CLOSE': 'Pending Close',
    '_75_START_DATE': 'Start Date',
    '_9774_START_DATE_': 'Start Date:',
    '_127_STATUS': 'Status',
    '_726_TARGET': 'Target',
    '_989_TREND': 'Trend',
    '_7398_VARIANCE': 'Variance',
    '_203_WEEKLY': 'Weekly',
    '_76_TYPE': 'Type',
    '_7533_COMMITMENT': 'Commitment',
    '_9775_NEW_COMMITMENT': 'New Commitment',
    '_9776_EDIT_COMMITMENT': 'Edit Commitment',
    '_9777_CLICK_HERE_TO_SET_THE_FOCUS_FOR_THIS_COMMITMENT': 'Click here to set the Focus for this Commitment',
    '_9778_SELECT_A_METRIC': 'Select a Metric',
    '_9779_EXPECTED_ACHIEVEMENT_DATE': 'Expected Achievement Date',
    '_9780_LINK_ANOTHER_OBSERVATION': 'Link another Observation',
    '_9781_START_A_NEW_OBSERVATION': 'Start a new Observation',
    '_9782_UNLINK_OBSERVATION': 'Unlink Observation',
    '_9783_DATE_': 'Date:',
    '_965_DATE': 'Date',
    '_9784_NOTES': 'Notes',
    '_9785_INTERACTIONS': 'Interactions',
    '_9786_OVERALL_OPPORTUNITY_TO_DEMONSTRATE': 'Overall Opportunity to Demonstrate',
    '_9787_OVERALL_WILLINGNESS_TO_TRY': 'Overall Willingness to Try',
    '_9414_OVERALL_PROFICIENCY_SCORE': 'Overall Proficiency Score',
    '_121_CANCEL': 'Cancel',
    '_7425_EDIT': 'Edit',
    '_7424_DELETE': 'Delete',
    '_9415_PUBLISH': 'Publish',
    '_9416_SAVE_DRAFT': 'Save Draft',
    '_9417_DURATION_': 'Duration:',
    '_9418_UNLINK': 'Unlink',
    '_9419_TYPE_': 'Type:',
    '_9420_STATUS_': 'Status:',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9421_PUBLISHED_OBSERVATIONS': 'Published Observations',
    '_9422_BEHAVIOUR_': 'Behaviour:',
    '_9423_SUB_BEHAVIOUR_': 'Tactic:',
    '_9424_COMMITMENT_FOCUS': 'Commitment Focus',
    '_9425_OK': 'OK',
    '_9426_ACTIVE_GOALS': 'Active Goals',
    '_9427_GOAL_METRIC': 'Goal Metric',
    '_9428_YOU_NEED_TO_SET_A_GOAL_HERE': 'You need to set a goal here',
    '_9429_SHOW_SUPERGROUP_AVG': 'Show Supergroup Avg.',
    '_9430_NO_METRIC_PERFORMANCE_DATA': 'No Metric Performance Data.',
    '_4106_CURRENT_ACTUAL': 'Current Actual',
    '_9431__IMPROVEMENT_EXPECTED': '% Improvement Expected',
    '_9432_GOAL_VALUE': 'Goal Value',
    '_9433_START___TO_GOAL': 'Start % to Goal',
    '_9434_DAYS_TO_ACHIEVEMENT': 'Days to Achievement',
    '_9435_TOTAL_DAYS_OPPORTUNITY_ACTIVE': 'Total Days Opportunity Active',
    '_9436_GOAL_CREATOR': 'Goal Creator',
    '_9437_UPDATE_GOAL': 'Update Goal',
    '_9438_SEE_GOAL_HISTORY': 'See Goal History',
    '_9439_DELETE_THIS_GOAL': 'Delete This Goal',
    '_9440_CLOSE_THIS_GOAL': 'Close This Goal',
    '_9441_ACCEPT_CHANGES': 'Accept Changes',
    '_9442_CANCEL_REVIEW': 'Cancel Review',
    '_9443_DECLINE_CHANGES': 'Decline Changes',
    '_9444_THIS_GOAL_IS_BEING_SHARED_ACROSS_OTHER_COMMITMENTS__SEE_THE_OTHER_COMMITMENT_HERE_': 'This goal is being shared across other commitments, see the other commitment here.',
    '_9445_IMPROVEMENT_SINCE_LAST_GOAL': 'Improvement Since Last Goal',
    '_9446_OVERALL_IMPROVEMENT': 'Overall Improvement',
    '_9447_CREATE_NEW_GOAL': 'Create a New Goal',
    '_9448_GOAL_REVIEW': 'Goal Review',
    '_9449_GOAL_UPDATE': 'Goal Update',
    '_9450_ASSOCIATE_GOAL': 'Associate Goal',
    '_9451_SET_NEW_GOAL': 'Set New Goal',
    '_9452_SET_UPDATED_GOAL': 'Set Goal',
    '_9453_FROM_ANOTHER_COMMITMENT_': 'from another Commitment',
    '_7457_TARGET_LINE': 'Target Line',
    '_7456_ACTUAL_LINE': 'Actual Line',
    '_7458_GOAL_LINE': 'Goal Line',
    '_9454_ACTIVE_GOAL': 'Active Goal',
    '_7459_OPPORTUNITY_LINE': 'Opportunity Line',
    '_9455_HISTORIC_GOALS': 'Historic Goals',
    '_9457_COMMITMENT_EVENT': 'Commitment Event',
    '_9458_MULTIPLE_COACHING_EVENTS': 'Multiple Coaching Events',
    '_7313_LAST_UPDATED_': 'Last Update',
    '_9459_NEXT_COACHING_EVENT_': 'Next Coaching Event',
    '_9460_NO_UPDATES_YET': 'No updates yet',
    '_9461_NO_EVENT_SCHEDULE': 'No event scheduled',
    '_9462_DATE_SET': 'Date Set',
    '_9463_ACTIVE_GOAL_DAYS': 'Active Goal Days',
    '_9466_GOALS_ON_OTHER_COMMITMENTS': 'Goals on Other Commitments',
    '_9467_RECENTLY_CLOSED_GOALS': 'Recently Closed Goals',
    '_9468_SORT': 'Sort',
    '_714_30_DAY': '30 Day',
    '_9469_SESSION_TIME': 'Session Time',
    '_9470_TOTAL_TIME': 'Total Time',
    '_9471_APPROVE': 'Approve',
    '_9472_DISPUTE': 'Dispute',
    '_763_CLOSE': 'Close',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_9474_SELECT_GOAL_METRIC': 'Select Goal Metric',
    '_9475_PENDING_GOALS': 'Pending Goals',
    '_9476_DRAFT': 'Draft',
    '_9477_THE_FOCUS_CANNOT_BE_CHANGED_': 'The focus cannot be changed.',
    '_9478_THE_FOCUS_YOU_HAVE_SELECTED_IS_ALREADY_A_FOCUS_FOR_AN_ACTIVE_COMMITMENT': 'The focus you have selected is already a focus for an active commitment for the performer .Please select a different commitment focus.',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9480_SUPERGROUP_AVERAGE': 'Supergroup Average',
    '_9481_START_TIME_': 'Start time:',
    '_9482_FINISH_TIME_': 'Finish time:',
    '_9486_CREATOR_': 'Creator:',
    '_9487_COMMITMENT_NARRATIVE': 'Commitment Narrative',
    '_9488_ADD_COMMITMENT_NOTE': 'Add Commitment Note',
    '_9489_YOU_ARE_LEAVING_THIS_SESSION_': 'You are leaving this session.',
    '_9490_LEAVE': 'Leave',
    '_9491_STAY': 'Stay',
    '_9492_WARNING': 'Warning',
    '_9493_YOU_ARE_CHANGING_THE_SESSION_TIME_': 'You are changing the session time.',
    '_9494_YOU_ARE_SELECTING_A_DIFFERENT_METRIC__THIS_WILL_TAKE_YOU_OUTSIDE_THIS_FORM_': 'You are selecting a different metric, this will take you outside this form.',
    '_9495_PRE_APPROVAL': 'Pre-Approval',
    '_9496_DELETED': 'Deleted',
    '_8702_UPDATING': 'Updating',
    '_9497_DATE___TIME_': 'Date & Time:',
    '_9498_DO_YOU_WANT_TO_DELETE_THIS_DRAFT_GOAL_': 'Do you want to Delete this Draft Goal?',
    '_9499_THE_COMMITMENT_WAS_SAVED_': 'The commitment was saved.',
    '_9500_ARE_YOU_SURE_YOU_WANT_TO_SAVE_THIS_COMMITMENT': 'Are you sure you want to save this commitment?',
    '_9501_ARE_YOU_SURE_YOU_WANT_TO_CLOSE_THIS_COMMITMENT': 'Are you sure you want to close this commitment?',
    '_9503_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COMMITMENT': 'Are you sure you want to delete this commitment?',
    '_9504_DO_YOU_WANT_TO_LINK_AN_OBSERVATION_': 'Do you want to link an observation?',
    '_9505_DO_YOU_WANT_TO_CREATE_A_NEW_OBSERVATION_': 'Do you want to create a new observation?',
    '_9506_IN_ORDER_TO_CLOSE_THIS_PERFORMANCE_GOAL_YOU_MUST_SELECT_A_DISPOSITION': 'In order to close this Performance Goal you must select a disposition.',
    '_9507_A_COMMITMENT_CANNOT_BE_CREATED_UPDATED_WITHOUT_A_FOCUS_': 'A commitment cannot be created/updated without a focus.',
    '_9508_I_WILL': 'I will',
    '_9509_I_WILL_KNOW_THAT_I_AM_SUCCESSFUL_WHEN': 'I will know that I am successful when',
    '_9510_GENERAL_NOTES': 'General Notes',
    '_9511_DATE_IS_REQUIRED_': 'Date is required.',
    '_9512_INVALID_DATE_': 'Invalid Date.',
    '_9513_METRIC_IS_REQUIRED_': 'Metric is required.',
    '_9514_PLEASE_ENTER_A_FUTURE_ACTUAL_GOAL_OR_IMPROVEMENT_EXPECTED_': 'Please enter a Future Actual/Goal or Improvement Expected.',
    '_9515_EXPECTED_ACHIEVEMENT_DATE_IS_REQUIRED_': 'Expected Achievement Date is required.',
    '_9516_SELECT_KPI___': 'Select KPI...',
    '_9517_PLEASE_SELECT_DISPOSITION_REASON_BEFORE_PROCEEDING': 'Please select disposition reason before proceeding',
    '_9518_SEND_MY_DISPOSITION': 'Send my disposition',
    '_9519_SELECT_DISPOSITION_REASON': 'Select disposition reason',
    '_9520_YOU_ARE_DISPUTING_THIS_COMMITMENT__TELL_US_YOUR_REASONS': 'You are disputing this commitment, tell us your reasons',
    '_9521_SEND_MY_DISPUTE': 'Send my dispute',
    '_9522_SELECT_DISPUTE_REASON': 'Select dispute reason',
    '_9523_PLEASE_SELECT_DISPUTE_REASON_BEFORE_PROCEEDING': 'Please select dispute reason before proceeding',
    '_9524_THE_GOAL_HAS_BEEN_CLOSED': 'The goal has been closed',
    '_9525_B_': 'B:',
    '_9526_S_B_': 'Tactic:',
    '_9527_CLOSE_GOAL': 'Close Goal',
    '_741_GOAL_MET': 'Goal Met',
    '_9528_GOAL_MOSTLY_MET': 'Goal Mostly Met',
    '_9529_OTHER_PRIORITY': 'Other Priority',
    '_9530_NO_RELATIONSHIP_TO_BEHAVIOUR_FOCUS': 'No relationship to Behaviour Focus',
    '_9531_WOULD_YOU_LIKE_TO_SIGN_OFF_NOW_': 'Would you like to sign off now?',
    '_9532_SIGN_OFF': 'Sign Off',
    '_9533_SEND_NOTIFICATION': 'Send Notification',
    '_9534_EXPECTED_IMPROVEMENT___THIS_GOAL': 'Expected Improvement - This Goal',
    '_9535_CUMULATIVE_EXPECTED_IMPROVEMENT': 'Cumulative Expected Improvement',
    '_9536_OVERALL_ACTUAL_IMPROVEMENT_SINCE_START_OF_COMMIT': 'Overall Actual Improvement Since Start of Commit',
    '_9537_GOAL_HISTORY_FOR_': 'Goal History for:',
    '_9538_THERE_IS_NO_GOAL_HISTORY_FOR_THIS_METRIC_': 'There is no Goal History for this metric',
    '_9539_GOAL_DUE_DATE': 'Goal Due Date',
    '_7330_CREATED_BY': 'Created By',
    '_9541_GOAL_KPI_': 'Goal KPI:',
    '_9542_GOAL_': 'Goal:',
    '_9543_OTHER_COMMITMENTS_WITH_THIS_GOAL': 'Other Commitments with this goal',
    '_9544_GOALS_': 'Goals:',
    '_9545_SHARED_GOALS': 'Shared Goals',
    '_9546_THIS_PERFORMER_ALREADY_HAS_A_GOAL_WITH_THIS_METRIC_': 'This performer already has a goal with this metric. Would you like to review it? You will only be able to associate the goal, but not update it.',
    '_9547_REVIEW': 'Review',
    '_842_N_A': 'N/A',
    '_9548_OBSERVATION': 'Observation',
    '_640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_': '{{field_label}} is a required field. Please enter a {{field_label}}.',
    '_9741_NO_ACTIVE_GOALS': 'No Active Goals',
    '_9754_COMPLETE': 'Complete',
    '_9755_YOU': 'you',
    '_9756_THE_HIGHLIGHTED_ITEMS_WERE_SENT_BY': 'The highlighted items were sent by',
    '_9757_THE_HIGHLIGHTED_ITEMS_WERE_ACCEPTED_AND_DISPUTED_BY': 'The highlighted items were accepted and disputed by',
    '_9758_THE_HIGHLIGHTED_ITEMS_WERE_ACCEPTED_BY': 'The highlighted items were accepted by',
    '_9759_VIEW_UPDATES_SUMMARY': 'View Updates Summary',
    '_9760_ACCEPT_ALL_CHANGES': 'Accept all changes',
    '_9761_PLEASE_LOGIN_TO_VALIDATE_YOUR_DECISION': 'Please login to validate your decision',
    '_120_ACCEPT': 'Accept',
    '_9762_ACCEPTED': 'Accepted',
    '_8703_DISPUTED': 'Disputed',
    '_9763_LINKED': 'Linked',
    '_9764_UNLINKED': 'Unlinked',
    '_9766_UPDATED_TO': 'Updated To:',
    '_9767_ADDED': 'Added',
    '_9768_VIEW_SUMMARY': 'View Summary',
    '_9769_THE_COMMITMENT_FOR___FULLNAME___HAS_BEEN_SIGNED_OFF_SUCCESSFULLY': 'The commitment for {{fullName}} has been signed off successfully',
    '_9770_THE_COMMITMENT_FOR___FULLNAME___HAS_BEEN_SENT_FOR_APPROVAL': 'The commitment for {{fullName}} has been sent for approval',
    '_9771_THE_COMMITMENT_HAS_BEEN_SIGNED_OFF_SUCCESSFULLY_AND_IT_IS___STATUS___NOW': 'The commitment has been signed off successfully and it is {{status}} now',
    '_9772_THE_COMMITMENT_HAS_BEEN_SIGNED_OFF_AND_IT_IS_DRAFT_NOW': 'The commitment has been signed off and it is draft now',
    '_9701_READ_ONLY': 'Read Only',
    '_9788_THIS_COMMITMENT_IS_BEING_DISPUTED__IT_IS_THE_ORIGINAL': 'This commitment is being disputed. It is the original one and cannot be modified. To resolve this dispute please go to the Disputed section and find a copy of this commitment.',
    '_9789_READ___WRITE': 'Read - Write',
    '_9790_THIS_COMMITMENT_IS_BEING_DISPUTED__THIS_IS_THE_VERSION': 'This commitment is being disputed. This is the version with the changes to be disputed',
    '_9791_PENDING_APPROVAL': 'Pending Approval',
    '_9792_BEING_DISPUTED': 'Being Disputed',
    '_9793_DISPUTED_BY_ME': 'Disputed by Me',
    '_9794_DISPUTED_BY_ME_': 'Disputed by Me:',
    '_9795_DISPUTED_': 'Disputed:',
    '_9595_NEW': 'New',
    '_9796_PREVIOUS': 'Previous',
    '_9797_SET_THE_GOAL': 'Set the Goal',
    '_742_GOAL_UPDATED': 'Goal Updated',
    '_9798_EXPECTED_ACHIEVEMENT_DATE_UPDATED': 'Expected achievement date updated',
    '_9799_GOAL_CLOSE_REQUEST': 'Goal close request',
    '_9800_THE_TEXT_IS_REQUIRED': 'The text is required',
    '_9801_THE_HIGHLIGHTED_ITEMS_WERE_UPDATED_BY': 'The highlighted items were updated by',
    '_9802_IF_YOU_WANT_TO_UPDATE_THIS_COMMITMENT_PLEASE_GO_TO_THE_DRAFT': 'If you want to update this commitment please go to the draft',
    '_9803_THIS_DRAFT_HAS_AN_ACTIVE_COMMITMENT': 'This draft has an active commitment',
    '_9804_GO_TO_DRAFT_COMMITMENT': 'Go to Draft Commitment',
    '_9805_GO_TO_ACTIVE_COMMITMENT': 'Go to Active commitment',
    '_9561_ACTIVE_FOR_THIS_METRIC': 'Active for this Metric',
    '_9806_ACTIVE_FOR_OTHER_METRIC': 'Active for other Metric',
    '_9563_RECENTLY_CLOSED': 'Recently Closed',
    '_9807_DAYS_BEFORE_EXP__DATE': 'Days before Exp. Date',
    '_9808_DAYS_AFTER_EXP__DATE': 'Days after Exp. Date',
    '_9809_MISSED': 'Missed',
    '_9810_DRAFT__PENDING_CLOSE_': 'Draft (Pending Close)',
    '_9811_DISPUTED__PENDING_CLOSE_': 'Disputed (Pending Close)',
    '_9812_DISPUTED_BY_ME__PENDING_CLOSE_': 'Disputed by Me (Pending Close)',
    '_9569_TODAY': 'Today',
    '_9813_DAYS_TO_EXP__DATE': 'Days to Exp. Date',
    '_9814_ACTIVE__WITH_A_DRAFT_VERSION_': 'Active (With a Draft Version)',
    '_9815_THIS_GOAL_IS_BEING_DISPUTED__THIS_IS_THE_VERSION_': 'This Goal is being disputed. This is the version with the changes to be disputed',
    '_9816_DRAFT__WITH_AN_ACTIVE_VERSION_': 'Draft (With an Active Version)',
    '_9829_ACTIVE_FOR_THIS_COMMITMENT': 'Active for this commitment',
    '_9841_ACTIVE_FOR_OTHER_COMMITMENT': 'Active for other commitments',
    '_9832_COMMITMENT_SUMMARY': 'Commitment Summary',
    '_9833_MODIFIED_ELEMENT': 'Modified Element',
    '_9834_ACTION_TAKEN': 'Action Taken',
    '_9835_LINKED_OBSERVATIONS': 'Linked Observations',
    '_9837_KEEP_EDITING': 'Keep Editing',
    '_9838_SEND_FOR_APPROVAL': 'Send for approval',
    '_9839_ACCEPT_ALL_AND_SEND': 'Accept All and Send',
    '_9840_GO_TO_COMMITMENT': 'Go to commitment',
    '_9843_SEND': 'Send',
    '_7454_GOALS': 'Goals',
    '_9844_ACCEPT_ALL': 'Accept All',
    '_9981_ADD_AN_INTERACTION_NOTE': 'Add an Interaction Note',
    '_9982_CONVERSATION': 'Conversation',
    '_9983_COPY': 'Copy',
    '_9984_CREATE_NEW_OBSERVATION': 'Create new observation',
    '_9986_NO_BEHAVIOUR_SELECTED': 'No Behaviour Selected',
    '_9987_NO_SUB_BEHAVIOUR_SELECTED': 'No Tactic Selected',
    '_9988_PARTICIPANTS': 'Participants:',
    '_9990_REMOVE_ALL_NOTES': 'Remove All Notes',
    '_966_TIME': 'Time',
    '_9996_TRANSCRIPTS': 'Transcripts',
    '_102_USER_NAME': 'User Name',
    '_10016_ADD_BEHAVIOUR': 'Add Behaviour',
    '_10017_ENTER_DESCRIPTION': 'Please enter a description here',
    '_10018_SELECT_ADDITIONAL_BEHAVIOURS': 'Select additional Behaviours',
    '_9301_DESCRIPTION': 'Description',
    '_11042_DO_YOU_WANT_TO_SAVE_CHANGES_MADE_TO_THIS_COMMITMENT': 'Do you want to save changes made to this commitment?',
    '_11041_CHAT': 'Chat',
    '_11121_START_TEAMS_CHAT': 'Start Teams Chat',
    '_11122_PLEASE_SELECT_A_FOCUS_BEFORE_STARTING_A_NEW_CHAT': 'Please select a focus before starting a new chat',
    '_11123_A_CHAT_CANNOT_BE_STARTED_ON_AN_UNSAVED_COMMITMENT': 'A chat cannot be started on an unsaved commitment',
    '_11124_MANAGE_GOALS': 'Manage Goals',
    '_11125_A_FOCUS_MUST_BE_SELECTED_BEFORE_SETTING_GOALS': 'A focus must be selected before setting goals',
    '_637_OKAY': 'Okay',
    '___MEET': 'Meet'
};
